import { render, staticRenderFns } from "./StudentsBigSteps.vue?vue&type=template&id=7befff0c"
import script from "./StudentsBigSteps.vue?vue&type=script&lang=js"
export * from "./StudentsBigSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports